/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { EntityDataApi } from "../../IndexedDBApi";
import { WorkTechnicianBase } from "../../../../schema/generated/WorkTechnician";
import { idbEntityDefs } from "../../generated/entityDefs";

// 固有処理を持たない薄いDataApi。共通CRUD/キャッシュはEntityDataApiに集約。
export class WorkTechnicianDataApi extends EntityDataApi<WorkTechnicianBase> {
  public readonly def = idbEntityDefs.WorkTechnician;
}